/** @format */

import { Alert, Box, Button, CircularProgress, Stack } from "@mui/material";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "firemade";
import React, { useEffect, useState } from "react";

import { withCms } from "cms";
import { withLocales } from "locales";
import { withRouter } from "router";
import { withUI } from "ui";
import { SignIn, useUser } from "user";

import Logo from "logo";

const Home = (props) => {
	const user = useUser();
	const { authenticated } = user;
	const [isChecking, setIsChecking] = useState(false);

	useEffect(() => {
		if (authenticated) {
			setIsChecking(true);

			// Check if user has a project
			const checkProject = async () => {
				try {
					const billingStatus = user.billing("status") || "active";
					const docs = await getDocs(query(collection(db, "projects"), where("userId", "==", user.id)));

					if (docs.empty) {
						// No project - go to onboarding
						props.router.navigate("/en-us/pages/onboarding/5/opt-in/7");
					} else {
						// Has project - check billing status
						if (user.admin()) {
							// Admin goes to their project
							props.router.navigate(`/project/${docs.docs[0].id}`);
						} else {
							switch (billingStatus) {
								case "unregistered":
								case "incomplete":
								case "incomplete_expired":
								case "active":
								case "inactive":
								case "trialing":
								case "past_due":
								case "unpaid":
								case "canceled":
									props.router.navigate(`/en-us/app/workspace/${docs.docs[0].id}`);
									break;
								default:
									props.router.navigate("/en-us/pages/onboarding/5/opt-in/7");
									break;
							}
						}
					}

					setIsChecking(false);
				} catch (error) {
					console.error("Error checking project:", error);
					setIsChecking(false);
				}
			};

			checkProject();
		}
	}, [authenticated, user.id]);

	return (
		<Box>
			<Alert
				icon={false}
				severity="success"
				action={
					<Button
						variant="contained"
						color="success"
						size="small"
						onClick={() => {
							props.router.navigate("/en-us/pages/onboarding/5/opt-in/7");
						}}
					>
						Sign Up
					</Button>
				}
			>
				<b>We're upgrading our services. If you don't yet have an account, please sign up for free now!</b>
			</Alert>
			<Box
				sx={{
					width: "100vw",
					height: "calc(100vh - 200px)",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Stack spacing={3} alignItems="center">
					<Logo wordmark={true} />
					{isChecking ? <CircularProgress /> : <Box sx={{ width: "30vw" }}>{!authenticated && <SignIn />}</Box>}
				</Stack>
			</Box>
		</Box>
	);
};

export default withLocales(withUI(withCms(withRouter(Home))));
